export const PERMISSION_GROUPS = [
    {
        module: 'platform',
        label: 'Plattform',
        audience: 'platform',
        availableFrom: 1,
        permissions: [{ key: 'platform.tenants.manage', label: 'Mandanten verwalten' }],
    },
    {
        module: 'admin',
        label: 'Administration',
        audience: 'internal',
        availableFrom: 1,
        permissions: [
            { key: 'admin.tenant.manage', label: 'Unternehmensdaten, Branding und Domains bearbeiten' },
            { key: 'admin.users.read', label: 'Benutzer anzeigen' },
            { key: 'admin.users.manage', label: 'Benutzer anlegen, bearbeiten und sperren' },
            { key: 'admin.roles.manage', label: 'Rollen und Berechtigungen verwalten' },
            { key: 'admin.audit.read', label: 'Audit-Log einsehen' },
            { key: 'admin.records.unlock', label: 'Abgerechnete und abgeschlossene Vorgänge ändern, Gerätecodes nach Abschluss einsehen' },
        ],
    },
    {
        module: 'dashboard',
        label: 'Dashboard',
        audience: 'internal',
        availableFrom: 1,
        permissions: [{ key: 'dashboard.view', label: 'Dashboard anzeigen' }],
    },
    {
        module: 'customers',
        label: 'Kunden',
        audience: 'internal',
        availableFrom: 2,
        permissions: [
            { key: 'customers.read', label: 'Kunden anzeigen' },
            { key: 'customers.create', label: 'Kunden anlegen' },
            { key: 'customers.update', label: 'Kunden bearbeiten' },
            { key: 'customers.delete', label: 'Kunden löschen / anonymisieren' },
            { key: 'customers.portal_access', label: 'Portalzugänge von Kunden verwalten' },
        ],
    },
    {
        module: 'tickets',
        label: 'Tickets',
        audience: 'internal',
        availableFrom: 2,
        permissions: [
            { key: 'tickets.read', label: 'Tickets anzeigen' },
            { key: 'tickets.create', label: 'Tickets anlegen' },
            { key: 'tickets.update', label: 'Tickets bearbeiten' },
            { key: 'tickets.assign', label: 'Tickets zuweisen' },
            { key: 'tickets.comment_internal', label: 'Interne Notizen verfassen und lesen' },
            { key: 'tickets.delete', label: 'Tickets löschen' },
            { key: 'tickets.configure', label: 'Status, Kategorien und Bereiche konfigurieren' },
        ],
    },
    {
        module: 'repairs',
        label: 'Reparaturen',
        audience: 'internal',
        availableFrom: 3,
        permissions: [
            { key: 'repairs.read', label: 'Reparaturen anzeigen' },
            { key: 'repairs.intake', label: 'Geräte annehmen' },
            { key: 'repairs.work', label: 'Werkstattbearbeitung' },
            { key: 'repairs.quotes', label: 'Kostenvoranschläge erstellen' },
            { key: 'repairs.handover', label: 'Abholung dokumentieren' },
        ],
    },
    {
        module: 'devices',
        label: 'Geräte',
        audience: 'internal',
        availableFrom: 3,
        permissions: [
            { key: 'devices.read', label: 'Geräte anzeigen' },
            { key: 'devices.manage', label: 'Geräte verwalten' },
        ],
    },
    {
        module: 'forms',
        label: 'Formulare',
        audience: 'internal',
        availableFrom: 4,
        permissions: [
            { key: 'forms.read', label: 'Formulare und Einsendungen anzeigen' },
            { key: 'forms.manage', label: 'Formulare erstellen und veröffentlichen' },
        ],
    },
    {
        module: 'calendar',
        label: 'Kalender',
        audience: 'internal',
        availableFrom: 5,
        permissions: [
            { key: 'calendar.read', label: 'Termine anzeigen' },
            { key: 'calendar.manage', label: 'Termine planen' },
        ],
    },
    {
        module: 'integrations',
        label: 'Integrationen',
        audience: 'internal',
        availableFrom: 5,
        permissions: [
            { key: 'integrations.manage', label: 'Microsoft 365 und Zabbix konfigurieren' },
            { key: 'monitoring.read', label: 'Monitoring-Daten anzeigen' },
            { key: 'monitoring.acknowledge', label: 'Zabbix-Probleme bestätigen' },
        ],
    },
    {
        module: 'contracts',
        label: 'Wartungsverträge',
        audience: 'internal',
        availableFrom: 7,
        permissions: [
            { key: 'contracts.read', label: 'Verträge anzeigen' },
            { key: 'contracts.manage', label: 'Verträge verwalten' },
            { key: 'automations.manage', label: 'Automatisierungen und Eskalationen verwalten' },
        ],
    },
    {
        module: 'reports',
        label: 'Berichte',
        audience: 'internal',
        availableFrom: 8,
        permissions: [{ key: 'reports.read', label: 'Berichte und Statistiken anzeigen' }],
    },
    {
        module: 'billing',
        label: 'Abrechnung (Powerbird)',
        audience: 'internal',
        availableFrom: 8,
        permissions: [
            { key: 'billing.read', label: 'Abrechnungsübersicht anzeigen' },
            { key: 'billing.release', label: 'Vorgänge zur Abrechnung freigeben' },
            { key: 'billing.manage', label: 'Übernahme in Powerbird bestätigen und Pauschalen verwalten' },
        ],
    },
    {
        module: 'portal',
        label: 'Kundenportal',
        audience: 'customer',
        availableFrom: 2,
        permissions: [
            { key: 'portal.access', label: 'Kundenportal nutzen' },
            { key: 'portal.tickets.create', label: 'Anfragen erstellen' },
            { key: 'portal.company.tickets', label: 'Vorgänge des gesamten Unternehmens sehen' },
            { key: 'portal.company.users', label: 'Portalbenutzer des Unternehmens verwalten' },
            { key: 'portal.quotes.approve', label: 'Kostenvoranschläge freigeben' },
        ],
    },
];
export const ALL_PERMISSION_KEYS = PERMISSION_GROUPS.flatMap((g) => g.permissions.map((p) => p.key));
/** Platzhalter: `*` (alles) oder `modul.*`. */
export function isValidPermissionPattern(value) {
    if (value === '*')
        return true;
    if (value.endsWith('.*')) {
        const prefix = value.slice(0, -1);
        return ALL_PERMISSION_KEYS.some((k) => k.startsWith(prefix));
    }
    return ALL_PERMISSION_KEYS.includes(value);
}
export function isPlatformPermission(value) {
    return value === '*' || value === 'platform.*' || value.startsWith('platform.');
}
export function hasPermission(granted, required) {
    for (const g of granted) {
        if (g === '*' || g === required)
            return true;
        if (g.endsWith('.*') && required.startsWith(g.slice(0, -1)))
            return true;
    }
    return false;
}
//# sourceMappingURL=permissions.js.map